import { createSelector } from 'reselect';
import _ from 'lodash';

import { getMusicState } from './music';

export const getSessionState = createSelector(
  [getMusicState],
  music => _.get(music, 'session'),
);

export const getSessionModel = createSelector(
  [getSessionState],
  session => _.get(session, 'model'),
);

export const getSessionToken = createSelector(
  [getSessionModel],
  model => _.get(model, 'cm_access_token'),
);

export const getHasSubscription = createSelector(
  [getSessionModel],
  model => _.get(model, 'hasSubscription'),
);

export const getSessionLoading = createSelector(
  [getSessionState],
  session => _.get(session, 'loading'),
);

export const getHasTokenLoadedOnce = createSelector(
  [getSessionState],
  session => _.get(session, 'hasLoadedOnce'),
);

export const getSessionError = createSelector(
  [getSessionState],
  session => _.get(session, 'error', false),
);
